import * as minievent from '../miniEvents';

import { InteractionEventMessage } from './InteractionEventMessage';

import type { TrackInteractionEvent } from '@web-platform/shared-universal-types-tracking/src/trackInteractionEvent/trackInteractionEvent';

export const trackInteractionEvent: TrackInteractionEvent = (eventData) =>
  minievent.track('funnel_events', 'tallyman.InteractionEvent', InteractionEventMessage(eventData));
